import { render, staticRenderFns } from "./MultiselectDialog.vue?vue&type=template&id=484c6e73&scoped=true&"
import script from "./MultiselectDialog.vue?vue&type=script&lang=js&"
export * from "./MultiselectDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDialog.vue?vue&type=style&index=0&id=484c6e73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c6e73",
  null
  
)

export default component.exports